import { OrganisationChange } from "./OrganisationChange";
import { RecognitionApplication } from "./RecognitionApplication";

export type Organisation = {
  id: string;
  accreditation: boolean;
  acronym: string;
  allowedToApply: boolean;
  createdByUpn: string;
  createdByDisplayName: string;
  modifiedByUpn: string;
  modifiedByDisplayName: string;
  assignedToUpn: string;
  assignedToDisplayName: string;
  email: string;
  legalName: string;
  listOfStandardFeesUrl: string;
  itemId: number;
  name: string;
  recognitionNumber: string;
  website: string;
  updateStatus?: number;
  hasCompanyNumber?: boolean;
  companyNumber: string;
  hasCharityNumber?: boolean;
  charityNumber?: string;
  isOtherUkLegalEntity?: boolean;
  otherLegalEntityType?: number;
  isRegisteredInOtherCountry?: boolean;
  otherCountryOfRegistration?: number;
  otherCountryIdentifier?: string;
  isIndividualOrPartnership?: boolean;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  postCode: string;
  country: number;
  phoneNumber: string;
  ofqualRecognisedOnDate?: Date;
  cceaRecognisedOnDate?: Date;
  ofqualSurrenderedDate?: Date;
  cceaSurrenderedDate?: Date;
  ofqualWithdrawnOnDate?: Date;
  cceaWithdrawnOnDate?: Date;
  organisationChanges: OrganisationChange[];
  createdDate: Date;
  modifiedDate: Date;
  dateOfIncorporation: Date;
  pendingRecognition: boolean;
  recognitionApplicationReleaseDate?: Date;
  recognitionLastActivatedDate?: Date;
  recognitionLastClosedDate?: Date;
  engagementCaseNotes?: string;
  engagementPerceivedUnderstanding?: number;
  engagementFollowUpDate?: Date;
  engagementLastClosedDate?: string;
  engagementLastActivatedDate?: string;
  isOnRoEPAOs?: number;
  hasSubmittedApplicationBefore?: number; // todo - make this nullable bool + change in the API/DB model.
  qualTypeIntendingToApplyForOther?: string;
  dateIntendingToApply?: Date;
  contactTitle?: number;
  contactFirstName?: string;
  contactSurname?: string;
  contactEmail?: string;
  contactRoleInOrg?: string;
  qualTypesToApplyFor: { qualificationTypeId: number }[];
  recognitionApplications: RecognitionApplication[];
  intendingToOrDeliveringEPAs?: boolean;
};

export const isClosedForEngagement = (org: Organisation | null | undefined) =>
  org &&
  org.engagementLastClosedDate &&
  (org.engagementLastClosedDate || "") >=
    (org.engagementLastActivatedDate || "");
